import analyticsHelpers from '../helpers/analytics-helpers';

// Initialize the GA events directive.
const gaEvent = {
  bind(el, binding) {
    el.addEventListener('click', () => {
      analyticsHelpers.gaEvent(binding.value.category, binding.value.action, binding.value.label);
    }, false);
  },
};

export {
  gaEvent,
};
